<template>
  <BasicLayout>
    <template #wrapper>
      <el-card :bordered="false" :body-style="{padding: '0'}">
        <div class="salesCard">
          <el-form :inline="true">
            <el-form-item label="平台" prop="platForm">
              <el-select v-model="queryParams.platForm" size="small" style="width: 130px" placeholder="请选择">
                <el-option
                  v-for="item in platForm"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="国家" prop="startDate">
              <el-select v-model="queryParams.country" filterable size="small" style="width: 150px" placeholder="请选择">
                <el-option
                  v-for="item in country"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="登录方式" prop="adChannel">
              <el-select v-model="queryParams.adChannel" filterable placeholder="请选择">
                <el-option
                  v-for="item in adChannel"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="开始日期">
              <el-date-picker
                v-model="queryParams.startDate"
                placeholder="请选择日期"
                clearable
                value-format="yyyy-MM-dd"
                type="date"
                size="small"
                style="width: 150px"
                @keyup.enter.native="handleQuery"
              />
            </el-form-item>
            <el-form-item label="结束日期">
              <el-date-picker
                v-model="queryParams.endDate"
                placeholder="请选择日期"
                clearable
                value-format="yyyy-MM-dd"
                type="date"
                size="small"
                style="width: 150px"
                @keyup.enter.native="handleQuery"
              />
            </el-form-item>
            <el-form-item>
              <el-button :loading="loading" type="primary" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
            </el-form-item>
          </el-form>
        </div>

        <div ref="chartContainer" style="width: 100%; height: 400px;" />
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getUserRemain } from '@/api/statistics/user_remain'
import echarts from 'echarts'
import { dateStrTodate } from '@/utils'

export default {
  name: 'IndexUserMain',
  data() {
    return {
      reelection: false,
      reelectionName: '',
      reelectionClick: 0,
      platForm: [{ label: '全部', value: '' }, { label: '安卓', value: 1 }, { label: '苹果', value: 2 }, { label: 'TG', value: 3 }],
      adChannel: [{ label: '全部', value: '' }, { label: '游客', value: 'GUEST' }, { label: 'FACEBOOK', value: 'FACEBOOK' }, { label: '苹果', value: 'APPLE' }, { label: '谷歌', value: 'GOOGLE' }],
      country: [],
      chartData: {},
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        startDate: '',
        endDate: '',
        country: '',
        platForm: '',
        adChannel: ''
      },
      loading: false,
      options: [],
      tableData: [],
      date: [],
      chart: {},
      option: {}
    }
  },
  created() {
    this.getTables()
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    handleKeyUp() {
      this.onSubmit()
    },
    resetQuery() {
      this.resetForm('queryForm')
      this.handleQuery()
    },
    handleQuery() {
      if (this.queryParams.startDate === '') {
        this.msgError('请选择开始日期')
        return
      }

      if (this.queryParams.endDate === '') {
        this.msgError('请选择结束日期')
        return
      }

      if (this.queryParams.startDate > this.queryParams.endDate) {
        this.msgError('开始日期不能与结束日期')
        return
      }

      this.loading = true
      this.chart.showLoading()
      this.getTables()
    },
    getTables() {
      getUserRemain(this.queryParams).then(res => {
        this.loading = false
        this.chart.hideLoading()
        if (res.code === 200) {
          this.tableData = res.data.r
          this.queryParams.startDate = res.data.req.startDate
          this.queryParams.endDate = res.data.req.endDate
          const country = res.data.country
          const remain = res.data.r
          const loginData = res.data.rl
          this.country = [{ value: '', label: '全部' }]
          for (const i in country) {
            this.country.push({ value: i, label: country[i] })
          }
          for (const i in remain) {
            const r = remain[i]
            for (const k in loginData) {
              const login = loginData[k]
              if (login.Date === r.date && r.regCount > 0) {
                let rate = (parseFloat((login.LogCount / r.regCount)) * 100).toFixed(2)
                if (rate > 100) {
                  rate = 100
                }
                remain[i].remain[login.DiffDay] = rate
              }
            }
          }
          const day1 = []
          const day3 = []
          const day4 = []
          const day5 = []
          const day6 = []
          const day7 = []
          const day15 = []
          const day30 = []
          this.date = []
          remain.forEach((item) => {
            // dateStrTodate(item.date)
            this.date.push(dateStrTodate(item.date))
            for (const i in item.remain) {
              const val = item.remain[i]
              const typ = parseInt(i)
              switch (typ) {
                case 1:
                  day1.push(val)
                  break
                case 2:
                  day3.push(val)
                  break
                case 3:
                  day4.push(val)
                  break
                case 4:
                  day5.push(val)
                  break
                case 5:
                  day6.push(val)
                  break
                case 6:
                  day7.push(val)
                  break
                case 14:
                  day15.push(val)
                  break
                case 29:
                  day30.push(val)
                  break
              }
            }
          })
          this.option.xAxis.data = this.date
          this.option.series[0].data = day1
          this.option.series[1].data = day3
          this.option.series[2].data = day4
          this.option.series[3].data = day5
          this.option.series[4].data = day6
          this.option.series[5].data = day7
          this.option.series[6].data = day15
          this.option.series[7].data = day30
          this.chart.setOption(this.option)
          // this.chart.on('legendselectchanged', this.handleClick)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    handleClick(params) {
      const clickName = params.name
      const selected = params.selected
      if (this.reelectionName === '') {
        this.reelectionName = clickName
        this.reelectionClick++
      } else if (this.reelectionName !== clickName) {
        this.resetLegend(selected)
        return
      }

      if (this.reelectionClick > 2 && this.reelectionName === clickName) {
        this.resetLegend(selected)
        return
      }

      this.reelectionClick++
      const reelection = this.reelection
      for (const i in selected) {
        if (i === clickName) {
          selected[i] = !reelection
        } else {
          selected[i] = reelection
        }
      }
      this.reelection = !reelection
      this.chart.setOption({
        legend: {
          selected: selected
        }
      })
    },
    resetLegend(selected) {
      for (const i in selected) {
        selected[i] = true
      }
      this.reelectionName = ''
      this.reelection = false
      this.chart.setOption({
        legend: {
          selected: selected
        }
      })
      this.reelectionClick = 0
    },
    numFormatter(row, column, cellValue, index) {
      return cellValue + '%'
    },
    initChart() {
      this.chart = echarts.init(this.$refs.chartContainer)
      this.option = {
        title: {
          text: '用户注册留存'
        },
        xAxis: {
          name: '',
          type: 'category',
          data: []
        },
        legend: {
          data: ['次日', '3日', '4日', '5日', '6日', '7日', '15日', '30日'],
          x: 'center',
          y: 'bottom',
          selected: {
            '次日': true,
            '3日': true,
            '4日': false,
            '5日': false,
            '6日': false,
            '7日': true,
            '15日': false,
            '30日': false
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value}%' // 使用默认的数值格式
          },
          axisLine: {
            show: false // 隐藏 y 轴的竖线
          }
        },
        toolbox: {
          show: true,
          feature: {
            // dataView: { readOnly: false },
            // magicType: { type: ['line', 'bar'] },
            // restore: {},
            // saveAsImage: {}
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        series: [
          {
            name: '次日',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}%' // 显示数值
            }
          },
          {
            name: '3日',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}%' // 显示数值
            }
          },
          {
            name: '4日',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}%' // 显示数值
            }
          },
          {
            name: '5日',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}%' // 显示数值
            }
          },
          {
            name: '6日',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}%' // 显示数值
            }
          },
          {
            name: '7日',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}%' // 显示数值
            }
          },
          {
            name: '15日',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}%' // 显示数值
            }
          },
          {
            name: '30日',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}%' // 显示数值
            }
          }
        ]
      }
      this.chart.setOption(this.option)
    }
  }
}
</script>

<style scoped>
</style>
